import { applicationType } from '@contember-cloud/studio-dsl';
import { z } from 'zod';
const pluginDependency = z.object({
    name: z.string(),
    version: z.string(),
    type: z.union([z.literal('production'), z.literal('development')]),
});
const plugin = z.object({
    id: z.string(),
    organizationId: z.string().nullable(),
    name: z.string(),
    slug: z.string(),
    description: z.string().nullable(),
    createdAt: z.string(),
    archivedAt: z.string().nullable(),
    activeRelease: z
        .object({
        id: z.string(),
        type: z.union([z.literal('field_attached'), z.literal('basic')]),
        description: z.string().nullable(),
        dependencies: z.array(pluginDependency).nullable(),
        schema: z.string().nullable(),
        handler: z.string(),
        handlerArgs: z.string().nullable(),
        createdAt: z.string(),
    })
        .nullable(),
});
export const projectSliceState = z.object({
    id: z.string().optional(),
    personId: z.string().optional(),
    intent: z.string().optional(),
    streamingStep: z
        .union([z.literal('applicationName'), z.literal('applicationType'), z.literal('intentStatus'), z.literal('whatIsWrong')])
        .optional(),
    name: z.string().optional().nullable(),
    organizationId: z.string().optional().nullable(),
    type: applicationType.optional().nullable(),
    specification: z.string().optional().nullable(),
    repositoryId: z.string().optional().nullable(),
    cloudAdminUrl: z.string().optional().nullable(),
    cloudSelfcareUrl: z.string().optional().nullable(),
    showDebugger: z.boolean().optional().nullable(),
    showOptionsPanel: z.boolean().optional().nullable(),
    isSaved: z.boolean().nullable(),
    isStreaming: z.boolean(),
    isDownloadable: z.boolean().nullable().optional(),
    isCodeAvailable: z.boolean().optional().nullable(),
    plugins: z.array(plugin),
});
//# sourceMappingURL=projectSlice.js.map